import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const UserPasswordDialog = ({ user, onClose }) => {
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [busy, setBusy] = useState(false);

  const run = async (fn, okText) => {
    setBusy(true);
    setMsg({ type: "", text: "" });
    try {
      const { data } = await fn();
      if (data.ok === false) setMsg({ type: "error", text: `Email not sent (${data.status}): ${data.error || "unknown error"}` });
      else setMsg({ type: "ok", text: okText });
    } catch (e) {
      setMsg({ type: "error", text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    } finally {
      setBusy(false);
    }
  };

  const setTemp = (e) => {
    e.preventDefault();
    run(() => api.post(`/admin/users/${user.id}/set-password`, { password }),
      "Temporary password saved. Share it with the user privately and ask them to change it.");
    setPassword("");
  };

  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white" data-testid="admin-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif">Reset password</DialogTitle>
          <DialogDescription>{user?.name} · {user?.email}</DialogDescription>
        </DialogHeader>
        <form onSubmit={setTemp} className="space-y-3">
          <label className="eyebrow block" htmlFor="temp-password">Set a temporary password</label>
          <input id="temp-password" type="text" required minLength={6} value={password}
            onChange={(e) => setPassword(e.target.value)} className="input-field"
            placeholder="At least 6 characters" autoComplete="off" data-testid="admin-temp-password-input" />
          <button type="submit" disabled={busy} className="btn-primary w-full !rounded-xl !py-2 text-sm"
            data-testid="admin-temp-password-save">Save temporary password</button>
        </form>
        <div className="border-t border-[#E8ECEA] pt-3">
          <button type="button" disabled={busy} className="btn-secondary w-full !rounded-xl !py-2 text-sm"
            onClick={() => run(() => api.post(`/admin/users/${user.id}/send-reset-link`), "Reset link emailed to the user.")}
            data-testid="admin-send-reset-link">Email them a reset link instead</button>
        </div>
        {msg.text && (
          <div data-testid="admin-password-message"
            className={`text-xs rounded-lg px-3 py-2 border ${msg.type === "ok"
              ? "text-[#2F524A] bg-[#F4F7F6] border-[#E8ECEA]"
              : "text-[#9B2C2C] bg-[#FCEDED] border-[#F5C2C2]"}`}>
            {msg.text}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
